import styled, { css } from 'styled-components';
import { getColor } from 'core/utils/Styles';

export const Link = styled.a`
	display: flex;
	flex-direction: column;
	text-decoration: none;
	padding: 0 8px;
	width: 350px;
	flex-basis: 350px;
	max-width: 350px;
	min-width: 350px;

	&:hover, &:focus {
		text-decoration: none;
	}

	/* Show the last gap to the right */
	&:last-child {
		position: relative;

		&:after {
			content: '';
			width: 16px;
			height: 100%;
			display: block;
			position: absolute;
			top: 0;
			right: -15px;
		}
	}
`;

export const Frame = styled.div`
	overflow: hidden;
	position: relative;
	padding-top: 76.5%;
	background-color: ${getColor('gray1')};
	margin-bottom: 14px;
	border-radius: 8px;
`;

export const Pic = styled.img`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	object-fit: cover;
`;

export const Tag = styled.div`
	/* Box model */
	position: absolute;
	bottom: 0;
	left: 0;
	height: 30px;
	border-radius: 0 4px 0 0;
	padding: 6px 15px;

	/* Text */
	letter-spacing: 2px;
	font-size: 13px;
	font-weight: 600;
	text-transform: uppercase;

	/* Colors */
	background: ${getColor('albescentWhite')};
	color: ${getColor('rustyNail')};
`;

export const Name = styled.h4`
	font-weight: 600;
	font-size: 16px;
	line-height: 17px;
	letter-spacing: 0.2px;
	margin: 8px 0;
	color: ${getColor("gray")};
`;

export const Caption = styled.p`
	font-size: 13px;
	line-height: 18px;
	color: ${getColor('dustyGray')};
	margin-bottom: 8px;
`;

export const Price = styled.p`
	color: ${getColor('salmon')};
	font-weight: 600;
	font-size: 13px;
	line-height: 18px;
	margin-top: auto;
`;
